var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { addCommasWithoutDecimal } from "@domains/utils/numberMethods";
import React from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTable from "../../../../../../../shared-library/components/GenericTable";
import SelectDropdown from "../../../../../../../shared-library/components/selectdropdown";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { paymentTypeOfLink } from "../Constant";
import { useSelector } from "react-redux";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import { getDateInFormat } from "@domains/utils/reportDates";
var Report = function () {
    var _a = __read(React.useState([]), 2), checked = _a[0], setChecked = _a[1];
    var _b = __read(React.useState(true), 2), checkedDisable = _b[0], setCheckedDisable = _b[1];
    var _c = __read(React.useState({}), 2), paylinkScenario = _c[0], setPaylinkScenario = _c[1];
    var _d = __read(React.useState(false), 2), loader = _d[0], setLoader = _d[1];
    var _e = __read(React.useState(), 2), paylinkResultData = _e[0], setPaylinkResultData = _e[1];
    var _f = __read(React.useState(false), 2), selected = _f[0], setSelected = _f[1];
    var _g = __read(React.useState(), 2), selectedData = _g[0], setSelectedData = _g[1];
    var _h = __read(React.useState(false), 2), selectedReason = _h[0], setSelectedReason = _h[1];
    var _j = __read(React.useState(false), 2), noDataMsg = _j[0], setNoDataMsg = _j[1];
    var _k = __read(React.useState(), 2), selectedReasonData = _k[0], setSelectedReasonData = _k[1];
    var _l = __read(React.useState(), 2), selectedStakeHolder = _l[0], setSelectedStackHolder = _l[1];
    var _m = __read(React.useState(), 2), dropdown = _m[0], setDropdown = _m[1];
    var handleCheck = function (event) {
        var updatedList = __spreadArray([], __read(checked), false);
        if (event.target.checked) {
            updatedList = __spreadArray(__spreadArray([], __read(checked), false), [event.target.value], false);
        }
        else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
        if (!updatedList || updatedList.length == 0) {
            setCheckedDisable(true);
        }
        else {
            setCheckedDisable(false);
        }
    };
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getPaylinkReportData = function () {
        setLoader(true);
        var reportObj = {
            fromDate: "",
            toDate: "",
            source: "",
            reason: selectedReasonData,
            stakeHolder: selectedStakeHolder,
            typeoflink: selectedData,
            accode: selectedAcount.accountCode,
        };
        di.clients
            .getPaylinkReport(reportObj)
            .then(function (resp) {
            if (resp && resp.length > 0) {
                setLoader(false);
                setNoDataMsg(false);
                setPaylinkResultData(resp);
            }
            else {
                setNoDataMsg(true);
                setPaylinkResultData([]);
                setLoader(false);
            }
        })
            .catch(function (error) {
            setNoDataMsg(false);
            setPaylinkResultData([]);
            setLoader(false);
        });
    };
    var getPaymentScenarioDetails = function () {
        di.clients
            .getPaylinkScenarioDetails()
            .then(function (apiresponse) {
            console.log("Payment Scenario Success", apiresponse);
            if (apiresponse.length > 0) {
                setPaylinkScenario(apiresponse[0]);
                var dropdownResp = apiresponse.map(function (record) {
                    return {
                        value: record.reasonname,
                        display: record.reasonname,
                    };
                });
                setDropdown(dropdownResp);
            }
            else {
                setPaylinkScenario({});
                setDropdown([]);
            }
        })
            .catch(function (error) {
            //setNoDataMsg(false);
            setPaylinkScenario({});
            setDropdown([]);
            console.log("Payment Scenario Failure", error.data);
        });
    };
    var killPaymentDetails = function (req) {
        var requestPayload = {
            paylinkIds: req,
        };
        di.clients
            .killPaymentLink(requestPayload)
            .then(function (apiresponse) {
            if (apiresponse.data === "true") {
                alert("Payment link deactivated");
                getPaylinkReportData();
            }
            console.log("Success", apiresponse.data);
        })
            .catch(function (error) {
            alert("Something went wrong");
            console.log("Failure", error.data);
            getPaylinkReportData();
        });
    };
    var generatePaymentDetails = function (amount) {
        var payload = {
            payinfo: [{ accountCode: selectedAcount.accountCode, amount: amount }],
            reason: selectedReasonData,
            validity: 0,
            //StakeHolder: formData.StakeHolder,
        };
        di.clients
            .generatePaymentLink(payload)
            .then(function (apiresponse) {
            alert(apiresponse.data);
            console.log("generate Paayment Success", apiresponse.data);
            getPaylinkReportData();
        })
            .catch(function (errors) {
            alert(errors.data);
            getPaylinkReportData();
            console.log("Generate Payment Failure", errors.data);
        });
    };
    React.useEffect(function () {
        getPaymentScenarioDetails();
    }, []);
    /*
  
  
        {
    srNo: number;
    createdDate: string;
    clientCode: string;
    amountRequested: number;
    amountAttempted: number;
    link: string;
    currentStatusOfLink: boolean;
    clickedByUser: boolean;
    moneyTransferedAttempted: boolean;
    ewPgRefNo: string;
    bankStatus: string;
    source: string;
    reason: string;
    stakeHolder: string;
    killLink: boolean;
  }
  
  
    */
    var PaymentReportColumn = [
        {
            columnName: "Sr No",
            key: "srNo",
            tdCustomFunction: function (key) {
                return (React.createElement("div", { className: "displayFlex input-checkbox-row" },
                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: key, onChange: function (e) {
                            handleCheck(e);
                        } }),
                    key));
            },
        },
        {
            columnName: "Instruction Date Time",
            key: "createdDate",
            tdCustomFunction: function (key) {
                return (React.createElement("div", { className: "displayFlex input-checkbox-row" }, getDateInFormat(key, "DD-MM-YY")));
            },
        },
        { columnName: "Client Id", key: "clientCode" },
        {
            columnName: "Amount Requested",
            key: "amountRequested",
            tdCustomFunction: function (key) {
                return addCommasWithoutDecimal(key);
            },
        },
        {
            columnName: "Amount Attempted",
            key: "amountAttempted",
            tdCustomFunction: function (key) {
                return addCommasWithoutDecimal(key);
            },
        },
        {
            columnName: "Current Status Of Link",
            key: "currentStatusOfLink",
            tdCustomFunction: function (key) {
                return React.createElement("span", null, key.toString());
            },
        },
        {
            columnName: "Clicked By User",
            key: "clickedByUser",
            tdCustomFunction: function (key) {
                return React.createElement("span", null, key.toString());
            },
        },
        {
            columnName: "Money Transfered Attempted",
            key: "moneyTransferedAttempted",
            tdCustomFunction: function (key) {
                return React.createElement("span", null, key.toString());
            },
        },
        { columnName: "EwPgRefNo", key: "ewPgRefNo" },
        { columnName: "Bank Status", key: "bankStatus" },
        { columnName: "Source", key: "source" },
        { columnName: "Reason", key: "reason" },
        { columnName: "Stake Holder", key: "stakeHolder" },
        {
            columnName: "Resend",
            key: "killLink",
            key2: "amountRequested",
            tdCustomFunction: function (key, key2) {
                return !key ? (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Resend", onClick: function () { return generatePaymentDetails(key2.toString()); } })) : ("NA");
            },
        },
        {
            columnName: "KillLink",
            key: "killLink",
            key2: "srNo",
            tdCustomFunction: function (key, key2) {
                return key ? (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Kill", onClick: function () {
                        // let val: Number = key2;
                        killPaymentDetails([key2]);
                    } })) : (key.toString());
            },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "pdb-40 m-0 grid-4fr-40 paymentlink-row" },
            React.createElement(Col, { className: "px-0" },
                React.createElement("div", { className: "px-0 mbt-5" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Type of link")),
                React.createElement(Col, { className: "px-0 leadpage-selectdropdown" },
                    React.createElement(SelectDropdown, { placeholder: "Select", placeholderClassName: "", id: "reason", name: "Reason", selected: true, required: true, downarrow: "edel-icon-arrow-down", dropdownOptions: paymentTypeOfLink, onChangeEvent: function (e) {
                            if (e.target.value !== "") {
                                setSelectedData(e.target.value);
                                setSelected(true);
                            }
                        } }))),
            React.createElement(Col, { className: "px-0" },
                React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Reason")),
                React.createElement(Col, { className: "px-0 leadpage-selectdropdown" },
                    React.createElement(SelectDropdown, { selected: true, placeholderClassName: "", placeholder: "Select", id: "reason", name: "Reason", required: true, downarrow: "edel-icon-arrow-down", dropdownOptions: dropdown || [], onChangeEvent: function (e) {
                            if (e.target.value !== "") {
                                setSelectedReasonData(e.target.value);
                                setSelectedReason(true);
                            }
                            //  handleChange(e);
                        } }))),
            React.createElement(Col, { className: "px-0" },
                React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Stake Holder")),
                React.createElement(Col, { className: "px-0 leadpage-selectdropdown" },
                    React.createElement(SelectDropdown, { placeholder: "Select", selected: true, placeholderClassName: "", id: "reason", name: "Reason", required: true, defaultValue: paylinkScenario.stakeholder, downarrow: "edel-icon-arrow-down", dropdownOptions: [
                            {
                                value: paylinkScenario.stakeholder,
                                display: paylinkScenario.stakeholder,
                            },
                        ], onChangeEvent: function (e) {
                            setSelectedStackHolder(e.target.value);
                            //  handleChange(e);
                        } }))),
            React.createElement(Col, { className: "px-0" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Search", type: "button", onClick: function () {
                        getPaylinkReportData();
                    }, disabled: !(selectedData && selectedReason && selectedStakeHolder), className: "dmSan" }))),
        React.createElement(Row, { className: "mx-0" },
            !loader && !noDataMsg && (React.createElement(GenericTable, { columns: PaymentReportColumn, data: paylinkResultData, loader: loader, parentClassName: "salestableParentClass paymentparentclass", tableClassName: "salestableclass MortagetableClass" })),
            !loader && (React.createElement("div", { className: "Errormsgdiv" }, noDataMsg && React.createElement(Errormsg, { icon: "", msg: "No Data Found" })))),
        React.createElement(Row, null,
            React.createElement(Col, { className: "px-0 taCenter pt-2 pb-2" },
                React.createElement(EdButton, { className: "dmSan", btnTyp: "midnight-blue", value: "Kill", disabled: checkedDisable, onClick: function () {
                        killPaymentDetails(checked);
                    } })))));
};
export default Report;
